import { create } from 'zustand';

type GlobalStoreType = {
  cloudImageUrl: string | null;
  setCloudImageUrl: (url: string | null) => void;
};

const useGlobalStore = create<GlobalStoreType>(set => ({
  cloudImageUrl: null,
  setCloudImageUrl: (url: string | null) => set({ cloudImageUrl: url }),
}));

export default useGlobalStore;
